import React, { useCallback, FC } from "react";
import { GroupBase, Props as SelectProps } from "react-select";
import { ISelectOption } from "src/@types/form";
import { SelectedItem } from "./SelectedItem";
import { Select } from "../Select";
import { OUTSIDE_VALUES_SELECT_STYLES } from "./constants";
import { IOutsideValuesMultiSelect } from "./types";

// CHANGE - temp
interface Props
  extends Omit<
      SelectProps<ISelectOption, boolean, GroupBase<ISelectOption>>,
      "options"
    >,
    IOutsideValuesMultiSelect {}

export const OutsideValuesMultiSelect: FC<Props> = ({
  onChange,
  options,
  selectedOptions,
  setSelectedOptions,
  ...props
}) => {
  const deleteValue = useCallback(
    (value: ISelectOption["value"]) => {
      const filteredOptions = selectedOptions.filter(
        (option) => option.value !== value
      );
      setSelectedOptions(filteredOptions);
    },
    [setSelectedOptions, selectedOptions]
  );

  const onChangeSelect = useCallback(
    (values: ISelectOption[]) => {
      setSelectedOptions(values);
    },
    [setSelectedOptions]
  );

  return (
    <div className="flex flex-col gap-3">
      <Select
        styles={OUTSIDE_VALUES_SELECT_STYLES}
        components={{}} // empty obj - default components
        onChange={onChangeSelect}
        value={selectedOptions}
        options={options}
        controlShouldRenderValue={false}
        isMulti
        placeholder=""
        {...props}
      />
      {Boolean(selectedOptions.length) && (
        <div className="flex items-center gap-2 flex-wrap">
          {selectedOptions.map((option) => (
            <SelectedItem key={option.id} onClick={deleteValue} {...option} />
          ))}
        </div>
      )}
    </div>
  );
};
